import type {Component} from 'grapesjs';
import type {CountdownUnit} from '@EmailMakerReact/lib/email-maker-countdown-library.types';
import type {EmailMakerControlProps} from '../../../../right-panel-registry.types';

export interface CountdownLabelFieldProps extends EmailMakerControlProps {
  unit: CountdownUnit;
}

export interface PendingLabelWrite {
  component: Component;
  value: string;
  timeout: ReturnType<typeof setTimeout>;
}

export const COUNTDOWN_LABEL_WRITE_DEBOUNCE_MS = 300;
export const COUNTDOWN_LABEL_MAX_LENGTH = 20;
